import { createAction } from 'typesafe-actions';
import { IGeoServerBlock } from '../../../@types/model/masterData/geoserver/block';

export default class MasterDataGeoServerActions {
    public static setLoadingBlockList = createAction('MASTER_DATA_GEOSERVER_SET_LOADING', resolve => (loading : boolean) => resolve(loading));
    public static setBlockList = createAction('MASTER_DATA_GEOSERVER_BLOCKS_SET', resolve => (blocks : Array<IGeoServerBlock>) => resolve(blocks));
}